const page_schema = {
    "tiers": [
        {
            "name": "Sample Types",
            "type": "checkbox",
            "id": "sample-types",
            "class_name": "tags",
            "child_name": "sample-type",
            "options": [
                {
                    "name": "Agarose/PAGE Gels",
                    "id": "agarose-page-gels"
                },
                {
                    "name": "Bacteria",
                    "id": "bacteria"
                },
                {
                    "name": "Blood",
                    "id": "blood"
                },
                {
                    "name": "Cells & Tissue",
                    "id": "cells-and-tissue"
                },
                {
                    "name": "Feces",
                    "id": "feces"
                },
                {
                    "name": "FFPE Tissue",
                    "id": "ffpe-tissue"
                },
                {
                    "name": "Fungus",
                    "id": "fungus"
                },
                {
                    "name": "Insect",
                    "id": "insect"
                },
                {
                    "name": "Plant",
                    "id": "plant"
                },
                {
                    "name": "Reaction Products & Aqueous Phase",
                    "id": "reaction-products-and-aqueous-phase"
                },
                {
                    "name": "Serum & Plasma",
                    "id": "serum-and-plasma"
                },
                {
                    "name": "Soil & Water",
                    "id": "soil-and-water"
                },
                {
                    "name": "Swabs & Saliva",
                    "id": "swabs-and-saliva"
                },
                {
                  "name": "TRI Reagent<sup>&reg;</sup>(s) Samples",
                  "id": "tri-reagent(s)"
                },
                {
                    "name": "Urine",
                    "id": "urine"
                },
                {
                    "name": "Virus",
                    "id": "virus"
                },
                {
                    "name": "Yeast",
                    "id": "yeast"
                }
            ]
        },
        {
            "name": "Features",
            "type": "checkbox",
            "id": "features",
            "class_name": "tags",
            "child_name": "feature",
            "options": [
                {
                    "name": "CE-IVD",
                    "id": "ce-ivd"
                },
                {
                    "name": "High-Throughput",
                    "id": "high-throughput"
                },
                {
                    "name": "Low Input",
                    "id": "low-input"
                },
                {
                    "name": "Lysis Tubes Included",
                    "id": "lysis-tubes-included"
                },
                {
                    "name": "DNase I Included",
                    "id": "dnase-i-included"
                },
                {
                    "name": "Proteinase K Included",
                    "id": "proteinase-k-included"
                },
                {
                    "name": "Microbial & Environmental RNA",
                    "id": "microbial-and-environmental-rna"
                }
            ]
        },
        {
            "name": "Formats",
            "type": "checkbox",
            "id": "formats",
            "class_name": "tags",
            "child_name": "format",
            "options": [
                {
                    "name": "Columns",
                    "id": "columns"
                },
                {
                    "name": "96-Well Plate",
                    "id": "ninety-six-well-plate"
                },
                {
                    "name": "Magnetic Beads",
                    "id": "magnetic-beads"
                }
            ]
        }
    ],
    "filters": [],
    "products": {
        "Direct-zol RNA Microprep Kits": {
            "title": "Direct-zol RNA Microprep Kits",
            "catalogNumbers": "R2060, R2061, R2062, R2063",
            "description": "Purify up to 10 µg (per prep) of high-quality, NGS-ready RNA from single cell and low inputs in TRI Reagent® and similar. Concentrate in as low as 6 µl.",
            "handle": "/collections/direct-zol-rna-kits/products/direct-zol-rna-microprep-kits",
            "navigation_image": "rna_extraction",
            "generalIndex": "998",
            "tags": [
                "bacteria",
                "blood",
                "cells-and-tissue",
                "feces",
                "fungus",
                "insect",
                "plant",
                "serum-and-plasma",
                "swabs-and-saliva",
                "tri-reagent(s)",
                "virus",
                "yeast",
                "low-input",
                "dnase-i-included",
                "columns"
            ],
            "filters": []
        },
        "Direct-zol RNA Miniprep Kits": {
            "title": "Direct-zol RNA Miniprep Kits",
            "catalogNumbers": "R2050, 2051, R2052, R2053",
            "description": "A streamlined RNA purification method of up to 50 µg (per prep) of high-quality, NGS-ready RNA directly from samples in TRI Reagent® and similar.",
            "handle": "/collections/direct-zol-rna-kits/products/direct-zol-rna-miniprep-kits",
            "navigation_image": "rna_extraction",
            "generalIndex": "998",
            "tags": [
                "bacteria",
                "blood",
                "cells-and-tissue",
                "feces",
                "fungus",
                "insect",
                "plant",
                "serum-and-plasma",
                "swabs-and-saliva",
                "tri-reagent(s)",
                "virus",
                "yeast",
                "dnase-i-included",
                "columns"
            ],
            "filters": []
        },
        "Direct-zol RNA Miniprep Plus Kits": {
            "title": "Direct-zol RNA Miniprep Plus Kits",
            "catalogNumbers": "R2070, R2070T, R2071, R2072, R2073",
            "description": "A streamlined RNA purification method of up to 100 µg (per prep) of high-quality, NGS-ready RNA directly from samples in TRI Reagent® and similar.",
            "handle": "/collections/direct-zol-rna-kits/products/direct-zol-rna-miniprep-plus-kits",
            "navigation_image": "rna_extraction",
            "generalIndex": "998",
            "tags": [
                "bacteria",
                "blood",
                "cells-and-tissue",
                "feces",
                "fungus",
                "insect",
                "plant",
                "serum-and-plasma",
                "swabs-and-saliva",
                "tri-reagent(s)",
                "virus",
                "yeast",
                "dnase-i-included",
                "columns"
            ],
            "filters": []
        },
        "Direct-zol-96 RNA Kits": {
            "title": "Direct-zol-96 RNA Kits",
            "catalogNumbers": "R2054, R2055, R2056, R2057",
            "description": "High-throughput (96-well) isolation of high-quality RNA directly from samples in TRI Reagent&reg and similar without phase separation.",
            "handle": "/collections/direct-zol-rna-kits/products/direct-zol-96-rna-kits",
            "navigation_image": "high_throughput_magbead_tri",
            "generalIndex": "998",
            "tags": [
                "bacteria",
                "blood",
                "cells-and-tissue",
                "feces",
                "fungus",
                "insect",
                "plant",
                "serum-and-plasma",
                "swabs-and-saliva",
                "tri-reagent(s)",
                "virus",
                "yeast",
                "high-throughput",
                "dnase-i-included",
                "ninety-six-well-plate"
            ],
            "filters": []
        },
        "Direct-zol-96 MagBead RNA": {
            "title": "Direct-zol-96 MagBead RNA",
            "catalogNumbers": "R2100, R2101, R2102, R2103",
            "description": "High-throughput (96-well), magnetic bead-based isolation of high-quality RNA directly from samples in TRI Reagent&reg and similar without phase separation.",
            "handle": "/collections/direct-zol-rna-kits/products/direct-zol-96-magbead-rna",
            "navigation_image": "high_throughput_magbead_tri",
            "generalIndex": "998",
            "tags": [
                "bacteria",
                "blood",
                "cells-and-tissue",
                "feces",
                "fungus",
                "insect",
                "plant",
                "serum-and-plasma",
                "swabs-and-saliva",
                "tri-reagent(s)",
                "virus",
                "yeast",
                "high-throughput",
                "dnase-i-included",
                "magnetic-beads"
            ],
            "filters": []
        },
        "Quick-RNA Microprep Kit": {
            "title": "<i>Quick</i>-RNA Microprep Kit",
            "catalogNumbers": "R1050, R1051",
            "description": "Purify up to 10 µg (per prep) of high-quality, NGS-ready RNA directly from single cell and low inputs. Concentrate in as low as 6 µl.",
            "handle": "/collections/quick-rna-kits/products/quick-rna-microprep-kit",
            "navigation_image": "quick_rna",
            "generalIndex": "998",
            "tags": [
                "bacteria",
                "cells-and-tissue",
                "feces",
                "fungus",
                "insect",
                "plant",
                "serum-and-plasma",
                "swabs-and-saliva",
                "virus",
                "yeast",
                "low-input",
                "dnase-i-included",
                "columns"
            ],
            "filters": []
        },
        "Quick-RNA Miniprep Kit": {
            "title": "<i>Quick</i>-RNA Miniprep Kit",
            "catalogNumbers": "R1054, R1055",
            "description": "RNA purification kit designed for the easy, reliable, and rapid isolation of up to 100 µg (per prep) DNA-free RNA from a wide range of cell and tissue samples.",
            "handle": "/collections/quick-rna-kits/products/quick-rna-miniprep-kit",
            "navigation_image": "quick_rna",
            "generalIndex": "998",
            "tags": [
                "bacteria",
                "cells-and-tissue",
                "feces",
                "fungus",
                "insect",
                "plant",
                "serum-and-plasma",
                "swabs-and-saliva",
                "virus",
                "yeast",
                "dnase-i-included",
                "columns"
            ],
            "filters": []
        },
        "Quick-RNA Miniprep Plus Kit": {
            "title": "<i>Quick</i>-RNA Miniprep Plus Kit",
            "catalogNumbers": "R1057, R1057T, R1058",
            "description": "Combines the Quick-RNA technology with DNA/RNA Shield, a unique preservation and lysis technology, and Proteinase K to enable easy, reliable isolation from biological samples including cells, solid tissue, and whole blood. ",
            "handle": "/collections/quick-rna-kits/products/quick-rna-miniprep-plus-kit",
            "navigation_image": "quick_rna",
            "generalIndex": "998",
            "tags": [
                "bacteria",
                "blood",
                "cells-and-tissue",
                "feces",
                "fungus",
                "insect",
                "plant",
                "serum-and-plasma",
                "swabs-and-saliva",
                "urine",
                "virus",
                "yeast",
                "dnase-i-included",
                "proteinase-k-included",
                "columns"
            ],
            "filters": [
                {
                    "filter": "blood",
                    "index": 3
                },
                {
                    "filter": "insect",
                    "index": 3
                }
            ]
        },
        "Quick-RNA MagBead": {
            "title": "<i>Quick</i>-RNA MagBead",
            "catalogNumbers": "R2132, R2133",
            "description": "High-throughput magnetic bead-based purification of total RNA (including small/miRNAs) from any sample.",
            "handle": "/collections/quick-rna-kits/products/quick-rna-magbead",
            "navigation_image": "quick_rna_magbead",
            "generalIndex": "998",
            "tags": [
                "bacteria",
                "blood",
                "cells-and-tissue",
                "feces",
                "fungus",
                "insect",
                "plant",
                "serum-and-plasma",
                "swabs-and-saliva",
                "urine",
                "virus",
                "yeast",
                "high-throughput",
                "dnase-i-included",
                "proteinase-k-included",
                "magnetic-beads"
            ],
            "filters": []
        },
        "Quick-RNA 96 Kit": {
            "title": "<i>Quick</i>-RNA 96 Kit",
            "catalogNumbers": "R1052, R1053",
            "description": "Innovative, high-throughput (96-well) RNA isolation kits designed for rapid isolation of high quality, DNA-free, total RNA from a wide range of cell and tissue samples.",
            "handle": "/collections/quick-rna-kits/products/quick-rna-96-kit",
            "navigation_image": "quick_rna_96",
            "generalIndex": "998",
            "tags": [
                "bacteria",
                "blood",
                "cells-and-tissue",
                "feces",
                "fungus",
                "insect",
                "plant",
                "serum-and-plasma",
                "swabs-and-saliva",
                "virus",
                "yeast",
                "high-throughput",
                "dnase-i-included",
                "ninety-six-well-plate"
            ],
            "filters": []
        },
        "Quick-RNA Midiprep Kit": {
            "title": "<i>Quick</i>-RNA Midiprep Kit",
            "catalogNumbers": "R1056",
            "description": "RNA purification kit designed for the easy, reliable, and rapid isolation of up to 1 mg total RNA from cultured cells or tissue samples. ",
            "handle": "/collections/quick-rna-kits/products/quick-rna-midiprep-kit",
            "navigation_image": "quick_rna",
            "generalIndex": "998",
            "tags": [
                "cells-and-tissue",
                "columns"
            ],
            "filters": []
        },
        "Quick-DNA/RNA Miniprep": {
            "title": "<i>Quick</i>-DNA/RNA Miniprep",
            "catalogNumbers": "D7001",
            "description": "Provides a quick method for the isolation of high quality genomic DNA (up to 100 µg) and total RNA (up to 50 µg) from small amounts of cells and tissue without the use of phenol.",
            "handle": "/collections/quick-dna-rna-kits/products/quick-dna-rna-miniprep",
            "navigation_image": "quick_dna_rna",
            "generalIndex": "998",
            "tags": [
                "bacteria",
                "blood",
                "cells-and-tissue",
                "feces",
                "fungus",
                "insect",
                "plant",
                "serum-and-plasma",
                "swabs-and-saliva",
                "virus",
                "yeast",
                "columns"
            ],
            "filters": []
        },
        "Quick-DNA/RNA Miniprep Plus Kit": {
            "title": "<i>Quick</i>-DNA/RNA Miniprep Plus Kit",
            "catalogNumbers": "D7003, D7003T",
            "description": "Combines the Quick-DNA/RNA technology with DNA/RNA Shield, a unique preservation and lysis technology, and Proteinase K to enable easy, reliable isolation from biological samples including cells, solid tissue, and whole blood. ",
            "handle": "/collections/quick-dna-rna-kits/products/quick-dna-rna-miniprep-plus-kit",
            "navigation_image": "quick_dna_rna",
            "generalIndex": "998",
            "tags": [
                "bacteria",
                "blood",
                "cells-and-tissue",
                "feces",
                "fungus",
                "insect",
                "plant",
                "serum-and-plasma",
                "swabs-and-saliva",
                "urine",
                "virus",
                "yeast",
                "dnase-i-included",
                "proteinase-k-included",
                "columns"
            ],
            "filters": []
        },
        "Quick-DNA/RNA Microprep Plus Kit": {
            "title": "<i>Quick</i>-DNA/RNA Microprep Plus Kit",
            "catalogNumbers": "D7005, D7005T",
            "description": "Combines the Quick-DNA/RNA technology with DNA/RNA Shield and Proteinase K to enable easy, reliable isolation of ≤5 µg DNA and ≤10 µg RNA from biological samples including cells, solid tissue, and whole blood.",
            "handle": "/collections/quick-dna-rna-kits/products/quick-dna-rna-microprep-plus-kit",
            "navigation_image": "quick_dna_rna",
            "generalIndex": "998",
            "tags": [
                "bacteria",
                "blood",
                "cells-and-tissue",
                "feces",
                "fungus",
                "insect",
                "plant",
                "serum-and-plasma",
                "swabs-and-saliva",
                "urine",
                "virus",
                "yeast",
                "low-input",
                "dnase-i-included",
                "proteinase-k-included",
                "columns"
            ],
            "filters": []
        },
        "Quick-DNA/RNA MagBead": {
            "title": "<i>Quick</i>-DNA/RNA MagBead",
            "catalogNumbers": "R2130, R2131",
            "description": "A high-throughput, magnetic bead-based purification of both high-quality DNA and total RNA (including small/microRNAs) from the same starting sample.",
            "handle": "/collections/quick-dna-rna-kits/products/quick-dna-rna-magbead",
            "navigation_image": "quick_dna_rna_magbead",
            "generalIndex": "998",
            "tags": [
                "bacteria",
                "blood",
                "cells-and-tissue",
                "feces",
                "fungus",
                "insect",
                "plant",
                "serum-and-plasma",
                "swabs-and-saliva",
                "urine",
                "virus",
                "yeast",
                "high-throughput",
                "dnase-i-included",
                "proteinase-k-included",
                "magnetic-beads",
                "ffpe-tissue"
            ],
            "filters": []
        },
        "Quick-DNA/RNA Viral Kit": {
            "title": "<i>Quick</i>-DNA/RNA Viral Kit",
            "catalogNumbers": "D7020, R7021",
            "description": "A fast viral DNA/RNA purification kit for viral DNA and RNA from plasma, serum, cell culture media, cellular suspensions, urine, blood, saliva and any other biological samples stored in DNA/RNA Shield.",
            "handle": "/collections/quick-dna-rna-viral-kits/products/quick-dna-rna-viral-kit",
            "navigation_image": "quick_dna_rna_viral",
            "generalIndex": "998",
            "tags": [
                "blood",
                "serum-and-plasma",
                "swabs-and-saliva",
                "urine",
                "virus",
                "columns"
            ],
            "filters": [
                {
                    "filter": "swabs-and-saliva",
                    "index": 3
                },
                {
                    "filter": "virus",
                    "index": 2
                }
            ]
        },
        "Quick-DNA/RNA Viral 96 Kit": {
            "title": "<i>Quick</i>-DNA/RNA Viral 96 Kit",
            "catalogNumbers": "D7022, D7023",
            "description": "High-throughput (96-well) isolation of high-quality viral DNA and/or RNA from a wide range of biological sources. ",
            "handle": "/collections/quick-dna-rna-viral-kits/products/quick-dna-rna-viral-96-kit",
            "navigation_image": "quick_dna_rna_viral_96",
            "generalIndex": "998",
            "tags": [
                "blood",
                "serum-and-plasma",
                "swabs-and-saliva",
                "urine",
                "virus",
                "high-throughput",
                "ninety-six-well-plate"
            ],
            "filters": []
        },
        "Quick-DNA/RNA Viral MagBead": {
            "title": "<i>Quick</i>-DNA/RNA Viral MagBead",
            "catalogNumbers": "R2140, R2140-E, R2141, R2141-E, R2143",
            "description": "High-throughput, magnetic bead-based purification of viral DNA and/or RNA from plasma, serum, urine, cell culture media, blood, saliva, cellular suspensions, biopsies and swab and fecal samples stored in DNA/RNA Shield.",
            "handle": "/collections/quick-dna-rna-viral-kits/products/quick-dna-rna-viral-magbead",
            "navigation_image": "quick_dna_rna_viral_magbead",
            "generalIndex": "998",
            "tags": [
                "blood",
                "serum-and-plasma",
                "swabs-and-saliva",
                "urine",
                "virus",
                "ce-ivd",
                "high-throughput",
                "proteinase-k-included",
                "magnetic-beads"
            ],
            "filters": []
        },
        "Load N' Go DNA/RNA Viral Kit": {
            "title": "Load N' Go DNA/RNA Viral Kit",
            "catalogNumbers": "R2143",
            "description": "Pre-loaded laboratory automation-ready reagent plates",
            "handle": "/products/load-n-go-dna-rna-viral-kit",
            "navigation_image": "quick_dna_rna_viral_magbead",
            "generalIndex": "998",
            "tags": [
                "blood",
                "serum-and-plasma",
                "swabs-and-saliva",
                "urine",
                "virus",
                "ce-ivd",
                "high-throughput",
                "proteinase-k-included",
                "magnetic-beads"
            ],
            "filters": []
        },
        "Quick-DNA/RNA HT": {
            "title": "<i>Quick</i>-DNA/RNA HT",
            "catalogNumbers": "R2150, R2150-E, R2151, R2151-E, R2152",
            "description": "The Quick-DNA/RNA HT kit is intended for rapid, high-throughput nucleic acid extraction (automated or manual) from any biological or clinical sample.",
            "handle": "/products/quick-dna-rna-ht",
            "navigation_image": "https://www.zymoresearch.com/cdn/shop/products/LowResProductImage-R2150-E_-R2151-E-Quick-DNA-RNA-HT_Dx_1200x.jpg",
            "generalIndex": "998",
            "tags": [
                "bacteria",
                "blood",
                "cells-and-tissue",
                "feces",
                "fungus",
                "insect",
                "plant",
                "serum-and-plasma",
                "swabs-and-saliva",
                "urine",
                "virus",
                "yeast",
                "ce-ivd",
                "high-throughput",
                "proteinase-k-included",
                "magnetic-beads"
            ],
            "filters": [
                {
                    "filter": "swabs-and-saliva",
                    "index": 1
                },
                {
                    "filter": "virus",
                    "index": 3
                }
            ]
        },
        "Quick-RNA Viral Kit": {
            "title": "<i>Quick</i>-RNA Viral Kit",
            "catalogNumbers": "R1034, R1034-E, R1035, R1035-E",
            "description": "A fast, reliable purification system for viral RNA from plasma, serum, cell culture media, cellular suspensions, urine, blood, saliva and any other biological samples stored in DNA/RNA Shield™.",
            "handle": "/collections/quick-rna-viral-kits/products/quick-rna-viral-kit",
            "navigation_image": "quick_dna_rna_viral",
            "generalIndex": "998",
            "tags": [
				"blood",
				"serum-and-plasma",
				"swabs-and-saliva",
				"urine",
				"virus",
				"ce-ivd",
				"columns"
            ],
            "filters": [
                {
                    "filter": "swabs-and-saliva",
                    "index": 2
                },
                {
                    "filter": "virus",
                    "index": 1
                }
            ]
        },
        "Quick-RNA Viral 96 Kit": {
            "title": "<i>Quick</i>-RNA Viral 96 Kit",
            "catalogNumbers": "R1040, R1040-E, R1041, R1041-E",
            "description": "High-throughput (96-well) isolation of high-quality viral RNA from a wide range of biological sources. ",
            "handle": "/collections/quick-rna-viral-kits/products/quick-rna-viral-96-kit",
            "navigation_image": "quick_dna_rna_viral_96",
            "generalIndex": "998",
            "tags": [
				"blood",
				"serum-and-plasma",
				"swabs-and-saliva",
				"urine",
				"virus",
				"ce-ivd",
				"high-throughput",
				"ninety-six-well-plate"
            ],
            "filters": []
        },
        "ZymoBIOMICS RNA Miniprep Kit": {
            "title": "ZymoBIOMICS RNA Miniprep Kit",
            "catalogNumbers": "R2001",
            "description": "Designed for purifying RNA from a wide array of sample inputs (e.g. feces, soil, plant, water, and biofilms). Ready for RT-PCR, arrays, sequencing, microbiome or metagenome analyses. ",
            "handle": "/collections/zymobiomics-rna-kits/products/zymobiomics-rna-miniprep-kit",
            "navigation_image": "microbiomics",
            "generalIndex": "998",
            "tags": [
				"bacteria",
				"feces",
				"fungus",
				"plant",
				"soil-and-water",
				"swabs-and-saliva",
				"virus",
				"yeast",
				"lysis-tubes-included",
				"dnase-i-included",
				"columns",
                "microbial-and-environmental-rna"
            ],
            "filters": [
                {
                    "filter": "bacteria",
                    "index": 1
                },
                {
                    "filter": "feces",
                    "index": 1
                },
                {
                    "filter": "fungus",
                    "index": 1
                },
                {
                    "filter": "soil-and-water",
                    "index": 1
                },
                {
                    "filter": "yeast",
                    "index": 2
                }
            ]
        },
        "ZymoBIOMICS MagBead RNA": {
            "title": "ZymoBIOMICS MagBead RNA",
            "catalogNumbers": "R2137, R2138",
            "description": "High-throughput, magnetic bead-based microbiome extraction kit designed for microbial RNA purification.",
            "handle": "/collections/zymobiomics-rna-kits/products/zymobiomics-magbead-rna",
            "navigation_image": "high_throughput_magbead_microbiomics",
            "generalIndex": "998",
            "tags": [
				"bacteria",
				"feces",
				"fungus",
				"plant",
				"soil-and-water",
				"swabs-and-saliva",
				"virus",
				"yeast",
				"high-throughput",
				"dnase-i-included",
				"proteinase-k-included",
				"magnetic-beads",
                "microbial-and-environmental-rna"
            ],
            "filters": []
        },
        "ZymoBIOMICS DNA/RNA Miniprep Kit": {
            "title": "ZymoBIOMICS DNA/RNA Miniprep Kit",
            "catalogNumbers": "R2002",
            "description": "Designed for purifying DNA and RNA from a wide array of sample inputs (e.g. feces, soil, plant, water, and biofilms). Ready for RT-PCR, arrays, sequencing, microbiome or metagenome analyses. ",
            "handle": "/collections/zymobiomics-dna-rna-kits/products/zymobiomics-dna-rna-miniprep-kit",
            "navigation_image": "microbiomics",
            "generalIndex": "998",
            "tags": [
				"bacteria",
				"feces",
				"fungus",
				"plant",
				"soil-and-water",
				"swabs-and-saliva",
				"virus",
				"yeast",
				"lysis-tubes-included",
				"dnase-i-included",
				"columns",
                "microbial-and-environmental-rna"
            ],
            "filters": [
                {
                    "filter": "fungus",
                    "index": 3
                },
                {
                    "filter": "feces",
                    "index": 3
                }
            ]
        },
        "ZymoBIOMICS MagBead DNA/RNA": {
            "title": "ZymoBIOMICS MagBead DNA/RNA",
            "catalogNumbers": "R2135, R2136",
            "description": "A high-throughput, magnetic bead-based microbiome extraction kit designed for microbial DNA and RNA purification.",
            "handle": "/collections/zymobiomics-dna-rna-kits/products/zymobiomics-magbead-dna-rna",
            "navigation_image": "high_throughput_magbead_microbiomics",
            "generalIndex": "998",
            "tags": [
				"bacteria",
				"feces",
				"fungus",
				"plant",
				"soil-and-water",
				"swabs-and-saliva",
				"virus",
				"yeast",
				"high-throughput",
				"dnase-i-included",
				"proteinase-k-included",
				"magnetic-beads",
                "microbial-and-environmental-rna"
            ],
            "filters": []
        },
        "Quick-DNA/RNA Pathogen Miniprep": {
            "title": "<i>Quick</i>-DNA/RNA Pathogen Miniprep",
            "catalogNumbers": "R1042, R1043",
            "description": "A spin-column based purification of pathogen DNA and RNA from a wide variety of vectors and tissue types transported and stored in DNA/RNA Shield™.",
            "handle": "/collections/quick-dna-rna-pathogen-kits/products/quick-dna-rna-pathogen-miniprep",
            "navigation_image": "pathogen",
            "generalIndex": "998",
            "tags": [
				"bacteria",
				"cells-and-tissue",
				"insect",
				"swabs-and-saliva",
				"virus",
				"proteinase-k-included",
				"columns"
            ],
            "filters": [
                {
                    "filter": "insect",
                    "index": 2
                }
            ]
        },
        "Quick-DNA/RNA Pathogen MagBead": {
            "title": "<i>Quick</i>-DNA/RNA Pathogen MagBead",
            "catalogNumbers": "R2145, R2146",
            "description": "High-throughput, magnetic bead-based purification of pathogen (virus, bacteria, protozoa) DNA and RNA from a wide variety of vectors (mosquitoes, fleas, ticks, etc.)",
            "handle": "/collections/quick-dna-rna-pathogen-kits/products/quick-dna-rna-pathogen-magbead",
            "navigation_image": "pathogen_magbead",
            "generalIndex": "998",
            "tags": [
				"bacteria",
				"cells-and-tissue",
				"insect",
				"swabs-and-saliva",
				"virus",
				"high-throughput",
				"proteinase-k-included",
				"magnetic-beads"
            ],
            "filters": []
        },
        "Quick-RNA Whole Blood": {
            "title": "<i>Quick</i>-RNA Whole Blood",
            "catalogNumbers": "R1201",
            "description": "Rapid isolation of total RNA from whole or partitioned blood or a cell pellet (after red blood cell lysis)",
            "handle": "/products/quick-rna-whole-blood",
            "navigation_image": "blood_tube",
            "generalIndex": "998",
            "tags": [
				"blood",
				"dnase-i-included",
				"proteinase-k-included",
				"columns"
            ],
            "filters": [
                {
                    "filter": "blood",
                    "index": 1
                }
            ]
        },
        "Quick-DNA/RNA Blood Tube Kit": {
            "title": "<i>Quick</i>-DNA/RNA Blood Tube Kit",
            "catalogNumbers": "R1151",
            "description": "Co-purify DNA and RNA from the DNA/RNA Shield Blood Collection Tube.",
            "handle": "/products/quick-dna-rna-blood-tube-kit",
            "navigation_image": "blood_tube",
            "generalIndex": "998",
            "tags": [
				"blood",
				"dnase-i-included",
				"proteinase-k-included",
				"columns"
            ],
            "filters": [
                {
                    "filter": "blood",
                    "index": 2
                }
            ]
        },
        "Quick-cfRNA Serum & Plasma Kit": {
            "title": "<i>Quick</i>-cfRNA Serum & Plasma Kit",
            "catalogNumbers": "R1059",
            "description": "Simple and reliable preparation of circulating cell-free RNA from serum, plasma and other biological fluids without toxic phenol-chloroform or cumbersome protein precipitation.",
            "handle": "/products/quick-cfrna-serum-plasma-kit",
            "navigation_image": "serum_and_plasma",
            "generalIndex": "998",
            "tags": [
				"serum-and-plasma",
				"urine",
				"proteinase-k-included",
				"columns"
            ],
            "filters": [
                {
                    "filter": "serum-and-plasma",
                    "index": 1
                }
            ]
        },
        "Quick-cfDNA/cfRNA Serum & Plasma Kit": {
            "title": "<i>Quick</i>-cfDNA/cfRNA Serum & Plasma Kit",
            "catalogNumbers": "R1072",
            "description": "Simple and efficient preparation of all circulating cell-free DNA and RNA from serum, plasma, and other biological fluids without toxic phenol-chloroform or cumbersome protein precipitation and removal steps.",
            "handle": "/products/quick-cfdna-rna-serum-plasma-kit",
            "navigation_image": "serum_and_plasma",
            "generalIndex": "998",
            "tags": [
				"serum-and-plasma",
				"urine",
				"proteinase-k-included",
				"columns"
            ],
            "filters": [
                {
                    "filter": "serum-and-plasma",
                    "index": 2
                }
            ]
        },
        "Quick-RNA Fecal/Soil Microbe Microprep Kit": {
            "title": "<i>Quick</i>-RNA Fecal/Soil Microbe Microprep Kit",
            "catalogNumbers": "R2040",
            "description": "An affordable fecal and soil RNA extraction kit designed for fast, easy isolation of total RNA including small RNAs from soil, sludge, sediment and fecal samples.",
            "handle": "/products/quick-rna-fecal-soil-microbe-microprep-kit",
            "navigation_image": "fecal_soil",
            "generalIndex": "998",
            "tags": [
				"bacteria",
				"feces",
				"fungus",
				"soil-and-water",
				"low-input",
				"lysis-tubes-included",
				"columns",
                "microbial-and-environmental-rna"
            ],
            "filters": [
                {
                    "filter": "bacteria",
                    "index": 2
                },
                {
                    "filter": "feces",
                    "index": 2
                },
                {
                    "filter": "soil-and-water",
                    "index": 2
                }
            ]
        },
        "Quick-RNA Fungal/Bacterial Miniprep Kit": {
            "title": "<i>Quick</i>-RNA Fungal/Bacterial Miniprep Kit",
            "catalogNumbers": "R2014",
            "description": "Designed for the simple and rapid isolation of RNA from tough-to-lyse fungi, up to 50 µg (per prep)",
            "handle": "/products/quick-rna-fungal-bacterial-miniprep-kit",
            "navigation_image": "fungal_bacterial",
            "generalIndex": "998",
            "tags": [
				"bacteria",
				"fungus",
				"yeast",
				"lysis-tubes-included",
				"columns",
                "microbial-and-environmental-rna"
            ],
            "filters": [
                {
                    "filter": "bacteria",
                    "index": 3
                },
                {
                    "filter": "fungus",
                    "index": 2
                },
                {
                    "filter": "yeast",
                    "index": 1
                }
            ]
        },
        "Quick-RNA Fungal/Bacterial Microprep Kit": {
            "title": "<i>Quick</i>-RNA Fungal/Bacterial Microprep Kit",
            "catalogNumbers": "R2010",
            "description": "Designed for the simple and rapid isolation of RNA from tough-to-lyse fungi, up to 10 µg (per prep)",
            "handle": "/products/quick-rna-fungal-bacterial-microprep-kit",
            "navigation_image": "fungal_bacterial",
            "generalIndex": "998",
            "tags": [
				"bacteria",
				"fungus",
				"yeast",
				"low-input",
				"lysis-tubes-included",
				"columns",
                "microbial-and-environmental-rna"
            ],
            "filters": []
        },
        "Quick-RNA Tissue/Insect Kit": {
            "title": "<i>Quick</i>-RNA Tissue/Insect Kit",
            "catalogNumbers": "R2030",
            "description": "Rapid isolation of total RNA from various insect and arthropod specimens.",
            "handle": "/products/quick-rna-tissue-insect-kit",
            "navigation_image": "tissue_insect",
            "generalIndex": "998",
            "tags": [
				"cells-and-tissue",
				"insect",
				"lysis-tubes-included",
				"columns",
                "microbial-and-environmental-rna"
            ],
            "filters": [
                {
                    "filter": "insect",
                    "index": 1
                }
            ]
        },
        "Quick-RNA Plant Kit": {
            "title": "<i>Quick</i>-RNA Plant Kit",
            "catalogNumbers": "R2024",
            "description": "Isolate inhibitor-free RNA from plant and seed samples.",
            "handle": "/products/quick-rna-plant-kit",
            "navigation_image": "plant",
            "generalIndex": "998",
            "tags": [
				"plant",
				"lysis-tubes-included",
				"columns",
                "microbial-and-environmental-rna"
            ],
            "filters": [
                {
                    "filter": "plant",
                    "index": 1
                }
            ]
        },
        "Quick-RNA FFPE Miniprep": {
            "title": "<i>Quick</i>-RNA FFPE Miniprep",
            "catalogNumbers": "R1008",
            "description": "A simple and reliable method for RNA isolation from the same formalin-fixed, paraffin embedded (FFPE) tissue sample. ",
            "handle": "/products/quick-rna-ffpe-miniprep",
            "navigation_image": "ffpe_section",
            "generalIndex": "998",
            "tags": [
				"ffpe-tissue",
				"dnase-i-included",
				"proteinase-k-included",
				"columns"
            ],
            "filters": []
        },
        "Quick-DNA/RNA FFPE Miniprep Kit": {
            "title": "<i>Quick</i>-DNA/RNA FFPE Miniprep Kit",
            "catalogNumbers": "R1009",
            "description": "A simple and reliable method for total nucleic acid isolation (DNA & RNA) from the same formalin-fixed, paraffin embedded (FFPE) tissue sample.",
            "handle": "/products/quick-dna-rna-ffpe-miniprep-kit",
            "navigation_image": "ffpe_section",
            "generalIndex": "998",
            "tags": [
				"ffpe-tissue",
				"dnase-i-included",
				"proteinase-k-included",
				"columns"
            ],
            "filters": [
                {
                "ffpe-tissue": 0
                }
            ]
        },
        "Pinpoint Slide RNA Isolation System": {
            "title": "Pinpoint Slide RNA Isolation System",
            "catalogNumbers": "R1003, R1007",
            "description": "Innovative products for the isolation of RNA from any targeted area of fresh, paraffin-fixed, or paraffin-embedded tissues sectioned onto a glass slide.",
            "handle": "/products/pinpoint-slide-rna-isolation-system",
            "navigation_image": "pinpoint_slide",
            "generalIndex": "998",
            "tags": [
				"cells-and-tissue",
				"ffpe-tissue",
				"proteinase-k-included",
				"columns"
            ],
            "filters": []
        },
        "ZR Urine RNA Isolation Kit": {
            "title": "ZR Urine RNA Isolation Kit",
            "catalogNumbers": "R1038, R1039",
            "description": "An innovative product designed for the easy, reliable and rapid isolation of total RNA from cells in urine samples.",
            "handle": "/products/zr-urine-rna-isolation-kit",
            "navigation_image": "urine",
            "generalIndex": "998",
            "tags": [
				"urine",
				"columns"
            ],
            "filters": [,
                {
                    "filter": "urine",
                    "index": 1
                }
            ]
        },
        "YeaStar RNA Kit": {
            "title": "YeaStar RNA Kit",
            "catalogNumbers": "R1002",
            "description": "Simple spin-column solution for isolating RNA from yeast using Zymolyase.",
            "handle": "/products/yeastar-rna-kit",
            "navigation_image": "yeast",
            "generalIndex": "998",
            "tags": [
				"fungus",
				"yeast",
				"columns"
            ],
            "filters": [
                {
                    "filter": "yeast",
                    "index": 3
                }
            ]
        },
        "RNA Clean & Concentrator-5": {
            "title": "RNA Clean & Concentrator-5",
            "catalogNumbers": "R1013, R1014, R1015, R1016",
            "description": "RNA clean up kits that provide a simple and reliable method for rapid preparation of high-quality, RT-PCR-ready, and DNA-free RNA (up to 10 µg).",
            "handle": "/collections/rna-clean-concentrator-kits-rcc/products/rna-clean-concentrator-5",
            "navigation_image": "rna_clean",
            "generalIndex": "998",
            "tags": [
				"reaction-products-and-aqueous-phase",
				"low-input",
				"dnase-i-included",
				"columns"
            ],
            "filters": []
        },
        "RNA Clean & Concentrator-25": {
            "title": "RNA Clean & Concentrator-25",
            "catalogNumbers": "R1017, R1018",
            "description": "RNA clean up kits that provide a simple and reliable method for rapid preparation of high-quality, RT-PCR-ready RNA (up to 50 µg).",
            "handle": "/collections/rna-clean-concentrator-kits-rcc/products/rna-clean-concentrator-25",
            "navigation_image": "rna_clean",
            "generalIndex": "998",
            "tags": [
				"reaction-products-and-aqueous-phase",
				"columns"
            ],
            "filters": []
        },
        "RNA Clean & Concentrator-100": {
            "title": "RNA Clean & Concentrator-100",
            "catalogNumbers": "R1019",
            "description": "RNA clean up kit that provides a simple and reliable method for rapid preparation of high-quality, RT-PCR-ready RNA (up to 1 mg).",
            "handle": "/collections/rna-clean-concentrator-kits-rcc/products/rna-clean-concentrator-100",
            "navigation_image": "rna_clean",
            "generalIndex": "998",
            "tags": [
				"reaction-products-and-aqueous-phase",
				"columns"
            ],
            "filters": []
        },
        "RNA Clean & Concentrator-96": {
            "title": "RNA Clean & Concentrator-96",
            "catalogNumbers": "R1080",
            "description": "RNA clean up kit that provides a simple and reliable method for high-throughput (96-well plate) preparation of high-quality, RT-PCR-ready RNA (up to 10 µg per well).",
            "handle": "/collections/rna-clean-concentrator-kits-rcc/products/rna-clean-concentrator-96",
            "navigation_image": "rna_clean_96",
            "generalIndex": "998",
            "tags": [
				"reaction-products-and-aqueous-phase",
				"high-throughput",
				"ninety-six-well-plate"
            ],
            "filters": []
        },
        "RNA Clean & Concentrator MagBead": {
            "title": "RNA Clean & Concentrator MagBead",
            "catalogNumbers": "R1081, R1082",
            "description": "Simple and reliable high-throughput (magnetic bead-based) method for the rapid preparation of high-quality, DNA-free RNA.",
            "handle": "/collections/rna-clean-concentrator-kits-rcc/products/rna-clean-concentrator-magbead",
            "navigation_image": "rna_clean_magbead",
            "generalIndex": "998",
            "tags": [
				"reaction-products-and-aqueous-phase",
				"high-throughput",
				"dnase-i-included",
				"magnetic-beads"
            ],
            "filters": []
        },
        "Oligo Clean & Concentrator": {
            "title": "Oligo Clean & Concentrator",
            "catalogNumbers": "D4060, D4061",
            "description": "Provides a streamlined method for efficient recovery and clean-up of DNA/RNA fragments and oligonucletides ≥ 16 nt from labeling (radioactive, biotin, DIG, etc.) and other enzymatic reactions.",
            "handle": "/collections/oligo-clean-concentrator-kits/products/oligo-clean-concentrator",
            "navigation_image": "oligo_clean",
            "generalIndex": "998",
            "tags": [
				"reaction-products-and-aqueous-phase",
				"columns"
            ],
            "filters": []
        },
        "ZR-96 Oligo Clean & Concentrator": {
            "title": "ZR-96 Oligo Clean & Concentrator",
            "catalogNumbers": "D4062, D4063",
            "description": "Clean any DNA and RNA oligos in high-throughput format and elute in 10 &micro;l",
            "handle": "/collections/oligo-clean-concentrator-kits/products/oligo-clean-concentrator-zr96",
            "navigation_image": "high_throughput_96_well_oligo_clean",
            "generalIndex": "998",
            "tags": [
				"reaction-products-and-aqueous-phase",
				"high-throughput",
				"ninety-six-well-plate"
            ],
            "filters": []
        },
        "Zymoclean Gel RNA Recovery Kit": {
            "title": "Zymoclean Gel RNA Recovery Kit",
            "catalogNumbers": "R1011",
            "description": "The Zymoclean Gel RNA Recovery Kit provides a quick and efficient purification method for recovery of RNA fragments from agarose gels.",
            "handle": "/products/zymoclean-gel-rna-recovery-kit",
            "navigation_image": "agarose_gel",
            "generalIndex": "998",
            "tags": [
				"agarose-page-gels",
				"columns"
            ],
            "filters": []
        },
        "ZR small-RNA PAGE Recovery Kit": {
            "title": "ZR small-RNA PAGE Recovery Kit",
            "catalogNumbers": "R1070",
            "description": "The ZR small-RNA PAGE Recovery Kit provides an easy and efficient method for the extraction of high quality small RNAs from polyacrylamide gels (native and/or denatured)",
            "handle": "/products/zr-small-rna-page-recovery-kit",
            "navigation_image": "page_gel",
            "generalIndex": "998",
            "tags": [
				"agarose-page-gels",
				"columns"
            ],
            "filters": []
        },
        "ssDNA/RNA Clean & Concentrator": {
            "title": "ssDNA/RNA Clean & Concentrator",
            "catalogNumbers": "D7010, D7011",
            "description": "Separation of single-stranded nucleic acids from double-stranded nucleic acids.",
            "handle": "/products/ssdna-rna-clean-concentrator",
            "navigation_image": "ssdna_rna_clean",
            "generalIndex": "998",
            "tags": [
				"reaction-products-and-aqueous-phase",
				"columns"
            ],
            "filters": []
        },
        "Quick-DNA/RNA Water Kit": {
            "title": "<i>Quick</i>-DNA/RNA Water Kit",
            "catalogNumbers": "R2044",
            "description": "The Quick-DNA/RNA™ Water Kit efficiently isolates inhibitor-free nucleic acids from large water samples, ideal for sensitive applications like ddPCR, RT-qPCR, and NGS.",
            "handle": "/products/quick-dna-rna-water-kit",
            "navigation_image": "https://www.zymoresearch.com/cdn/shop/files/R2044-quick-dna-rna-water-kit_large.jpg",
            "generalIndex": "998",
            "tags": [
				"soil-and-water",
				"lysis-tubes-included",
				"dnase-i-included",
				"columns",
				"magnetic-beads",
                "microbial-and-environmental-rna"
            ],
            "filters": [
                {
                    "filter": "soil-and-water",
                    "index": 3
                }
            ]
        }
    }
}